// src/pages/ForgotPasswordLanding.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordLanding() {
  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <img
          src="/icons/Propel_schools_logo.png"
          alt="Propel Schools"
          width={64}
          height={64}
          style={{ justifySelf:'center' }}
        />
        <h1 style={styles.h1}>Forgot your password?</h1>
        <p style={styles.p}>
          Choose your role so we can direct you to the correct reset process.
        </p>

        <Link to="/recover/educator" style={{ ...styles.btn, ...styles.educator }}>
          I’m an Educator
        </Link>
        <Link to="/recover/scholar" style={{ ...styles.btn, ...styles.scholar }}>
          I’m a Scholar
        </Link>

        <div style={styles.footer}>
          <Link to="/welcome" style={styles.link}>Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight:'100vh', display:'grid', placeItems:'center', background:'#F7F9FC', padding:24 },
  card: { width:460, maxWidth:'92vw', background:'#fff', padding:24, borderRadius:16, boxShadow:'0 10px 24px rgba(0,0,0,0.08)', display:'grid', gap:12 },
  h1: { margin:'4px 0 0', fontSize:24, color:'#003e73', textAlign:'center' },
  p: { margin:'0 0 8px 0', color:'#042d60', textAlign:'center' },
  btn: { height:48, border:'none', borderRadius:999, fontWeight:900, textDecoration:'none', display:'flex', alignItems:'center', justifyContent:'center' },
  educator: { background:'#003e73', color:'#fff' },
  scholar: { background:'#f9a21a', color:'#fff' },
  footer: { marginTop:8, textAlign:'center' },
  link: { color:'#003e73', textDecoration:'underline', fontWeight:700 }
};
